import { Pipe, PipeTransform } from '@angular/core';
import { RevisionStatus } from 'src/app/shared/models/autogenerated-piping';

@Pipe({
    name: 'pipingRevisionStatus',
    standalone: false
})
export class PipingRevisionStatusPipe implements PipeTransform {
  transform(value: RevisionStatus): string {
    switch (value) {
      case RevisionStatus.DRAFT:   return 'Draft';
      case RevisionStatus.REVIEW:   return 'In Review';
      case RevisionStatus.REVIEW_WITH_REJECTIONS:  return 'In Review (Contains Rejections)';
      case RevisionStatus.REVIEW_WITH_PENDING_COMMENTS:  return 'In Review (Pending Comments)';
      case RevisionStatus.APPROVAL:   return 'Ready to Publish';
      case RevisionStatus.APPROVAL_WITH_PENDING_COMMENTS:  return 'Ready (Pending Comments)';
      case RevisionStatus.PUBLISHED:   return 'Published';
      case RevisionStatus.RETIRED: return 'Retired';
      case RevisionStatus.REJECTED: return 'Rejected';
      default:                  return '';
    }
  }
}
